export default {
  methods: {
    calculateProductListPrice({rseq1, rseq2, rseq3}, qty = null, rate = 1) {
      if(!qty) {return Number(0).toFixed(2)}
      // variable assign
      const rm_cost_per_kg = Number(rseq1)
      const overheads = Number(rseq2)
      const gross_margin = Number(rseq3)
      const quantity_needed = Number(qty)
      const fx_rate = Number(rate)
      // end of variable assign

      // start of calculation
      const cost_per_kg_to_manufacture = ((quantity_needed *  rm_cost_per_kg) + overheads) / quantity_needed
      const list_price = cost_per_kg_to_manufacture / (1 - gross_margin / 100)
      return Number(list_price * fx_rate).toFixed(2)
    }
  }
}
